module.exports = __webpack_public_path__ + "media/images/flags/PT-45bd0b7fe311bf3ba4538904d2cc0f86.svg";